import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
    App,
    Home,
    About,
    HowItWorks,
    Toolkit,
    Media,
    FundRedirect,
    FundPrisonInvestments,
    List,
    Compare,
    Family,
    Legal,
    // Resources,
    NotFound,
    IndexFunds,
    TargetDateSeries,
    Companies,
  } from 'containers'

export default (store) => {
  return (
    <Route path="/" component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Routes */ }
      <Route path="/funds/:fundId/:investmentVehicleId/:ticker" component={FundRedirect}/>
      <Route path="/funds/:fundId/:investmentVehicleId" component={FundRedirect}/>
      <Route path="/fund/:name/:ticker/prison-industrial-complex-investments/:fundId/:investmentVehicleId" component={FundPrisonInvestments}/>
      <Route path="/funds" component={List}/>
      <Route path="/compare" component={Compare}/> { /* Compare */ }
      <Route path="/families" component={Family}/>
      <Route path="/about" component={About}/>
      <Route path="/how-it-works" component={HowItWorks}/>
      <Route path="/action-toolkit" component={Toolkit}/>
      <Route path="/media" component={Media}/>
      <Route path="/legal" component={Legal}/>
      <Route path="/companies" component={Companies}/>
      <Route path="/index-funds" component={List}/> { /* IndexFunds */ }
      <Route path="/target-date-funds" component={List}/> { /* TargetDateSeries */ }
      <Route path="/target-date-funds/:strategyName" component={List}/> { /* TargetDateSeries */ }
      
      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};
